import { TokenConstants } from '../types';

// TODO(arbitrum-sepolia): set the testnet token addresses. `wNativeAsset` /
// `WETH` must be the canonical Arbitrum Sepolia WETH deployment, and
// `InitialSwapTokens.output` a token that exists on the testnet. The
// nativeAsset placeholder (0xEeee...) is chain-agnostic and stays as-is.
const tokens: TokenConstants = {
  Popular: {
    Symbols: ['WBTC', 'DAI', 'USDC', 'BAL', 'USDT', 'WETH'],
  },
  InitialSwapTokens: {
    input: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    output: '',
  },
  Addresses: {
    nativeAsset: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    wNativeAsset: '',
    WETH: '',
    BAL: '',
  },
};

export default tokens;
